module.exports = "<div class=modal-header><h3 class=modal-title>{{title}}</h3></div><div class=modal-body><p>{{text}}</p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=modalCtrl.close()>OK</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/modal/info-modal.html
// module id = 506
// module chunks = 0